import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

/*Components*/
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from "../components/Section";




const Contact = () => {

  const isMobile = useMediaQuery({ maxWidth: 430 })
  const isTablet = useMediaQuery({ minWidth: 631, maxWidth: 951 });
  const isDesktop = useMediaQuery({ minWidth: 952 });
  
  const [mapWidth, setMapWidth] = useState('600px');
  const [mapHeight, setMapHeight] = useState('450px');
  

  useEffect(() => {
    console.log({ isMobile });
    console.log({ isTablet });
    console.log({ isDesktop });
    if (isMobile) {
      setMapWidth('280px');
    }

    if (isTablet) {
      setMapWidth('400px');
    }

    if (isDesktop) {
      setMapWidth('600px');
    }
  }, [isMobile, isTablet, isDesktop]);




  return (

    <>
    
      <Navbar/>


      <Section>
        <div className="m-2 d-flex flex-column gap-3 align-items-center">
          {/* Join */}
          <div className="d-flex flex-column justify-content-center text-center">
            <h2 className={`font-custom`}>Join Art Alive Art School</h2>
            <p>Download our <a className={`text-dark-main font-custom`} href="/application_form.pdf" download={true}>application form</a> and email it to <a className={`text-dark-main font-custom`} href="mailto:elaine@artalive.co.za" target="_blank">elaine@artalive.co.za</a>.</p>
          </div>

          {/* Contact */}
          <div className="d-flex flex-column justify-content-center text-center">
            <h2 className={`font-custom`}>Contact Art Alive Art School</h2>
            <p>WhatsApp us on  <a className={`text-dark-main font-custom`} href="http://wa.me/27845816340">084 581 6340</a></p>
            <p>Email us at  <a className={`text-dark-main font-custom`} href="mailto:elaine@artalive.co.za" target="_blank">elaine@artalive.co.za</a></p>
            <p>Find us on  <a className={`text-dark-main font-custom`} href="https://web.facebook.com/artaliveartschool#" target="_blank"> <i className="bi bi-facebook"></i> Facebook</a></p>
            <p>Follow us on  <a className={`text-dark-main font-custom`} href="https://www.instagram.com/art_alive_art_school/?utm_source=qr#" target="_blank"> <i className="bi bi-instagram"></i> Instagram</a></p>
          </div>

          <div className="d-flex flex-column justify-content-cetner align-items-center text-center">
            <h2 className={`font-custom`}>Where to Find Art Alive Art School</h2>
            <p>Find us at 56 11th Ave, Northmead, Benoni</p>
            <iframe
              title="Google Maps Location"
              src="https://maps.google.com/maps?q=56%2011th%20Ave,%20Northmead,%20Benoni&t=&z=13&ie=UTF8&iwloc=&output=embed"
              width={mapWidth}
              height={mapHeight}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </Section>


      <Footer/>
    
    </>

  );

}

export default Contact